// Feature flags for phased launch
// Flip these to true when ready to enable a feature, then redeploy

export const FEATURES = {
  chat: true,
  mealBuilder: true,
  recipeTransformer: true,
  menuDecoder: true,
  groceryOptimizer: true,
  plateView: true,
  mealPlanner: true,
} as const;

// Map tab IDs to feature flags
const TAB_TO_FEATURE: Record<string, keyof typeof FEATURES | null> = {
  home: null,       // always enabled
  search: "chat",   // "search" tab uses "chat" feature
  meal: "mealBuilder",
  recipe: "recipeTransformer",
  menu: "menuDecoder",
  grocery: "groceryOptimizer",
  plate: "plateView",
  planner: "mealPlanner",
  profile: null,    // always enabled
  admin: null,      // always enabled
};

export function isFeatureEnabled(tabId: string): boolean {
  const feature = TAB_TO_FEATURE[tabId];
  if (feature === null || feature === undefined) return true;
  return FEATURES[feature];
}
